import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'UserForm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    userId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('User')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.user.categoryName
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isRegister: 'userForm/isRegister',
      isModify: 'userForm/isModify'
    }),
    
    pageTitle () {
      return this.isRegister ?
        this.categoryName + '新規作成' :
        this.categoryName + '編集'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'userForm/loadModel',
      resetForm: 'userForm/reset'
    }),

    init () {
      this.loading = true

      //TODO
      let userParams = {
        userUuid: this.userId
      }
      let serviceParams = {}
      let linkedCmsMstParams = {}

      // データ読出し
      this.loadModel({
        targetId: this.userId,
        userParams: userParams,
        serviceParams: serviceParams,
        linkedCmsMstParams: linkedCmsMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}
